<script setup lang="ts">
import type { CanvassListItem } from "@/canvasses/types";
import { formatDatetime } from "@/utils/toFormattedDatetime";
import { Map, MapPin } from "@iconoir/vue";

const { canvassListItem } = defineProps<{
  canvassListItem: CanvassListItem;
}>();
</script>

<template>
  <dl>
    <div>
      <dt><Map /> <span class="visually-hidden">Gebiet</span></dt>
      <dd>{{ canvassListItem.area.name }}</dd>
    </div>
    <template v-if="canvassListItem.meetingPoint.time !== null">
      <div>
        <dt><MapPin /><span class="visually-hidden">Treffpunkt</span></dt>
        <dd>
          {{ formatDatetime(canvassListItem.meetingPoint.time) }}
        </dd>
      </div>
    </template>
  </dl>
</template>
